/**
 * A type-safe array filter callback, that filters out null and undefined values.
 */
export function arrayFilterNonNullable<T>(item: T): item is NonNullable<T> {
  return item !== null && item !== undefined
}
